import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useContext,
  useCallback,
} from "react";
import { AgGridReact } from "ag-grid-react";
import { grossDemandActions } from "../service/grossdemand.actions";
import { GrossDemandDetermination } from "../service/update";
import { Box, Button } from "@mui/material";
import "../component/grossCarSegmentDD.css";
import { CellClickedEvent, CellValueChangedEvent, RowClassRules } from "ag-grid-community";
import FleetPlanningToolbar from "./planning/FleetPlanningToolbar";
import FleetPlanningFooter from "./planning/FleetPlanningFooter";
import Loading from "./common/Loading";
import CachedIcon from "@mui/icons-material/Cached";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../util/state/globalAction";
import { snackbarTypes } from "../../../util/state/globalVariables";
import CustomLoader from "../../../util/component/CustomLoader";
import { ContextOperation } from "../context/OperationContext";
import { useHasScope } from "../../../config/globalConfig";
import { Tooltip } from "@mui/material";
import * as Mui from "@mui/material";
import Replay from "@mui/icons-material/Replay";

// interface Props {
//   tenant?: string;
// }
const GrossCarSegmentDDTable = (props: any) => {
  const hasScope = useHasScope;
  const gridRef = useRef<AgGridReact>(null);
  const userDemand = grossDemandActions();
  const [grossDemandDeterminationObject] =
    React.useState<GrossDemandDetermination>({});
  const [rows, setRows] = useState<any>([]);
  const [rows2, setRows2] = useState<any>([]);
  const [rowData, setRowData] = useState<any>([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [cellColor, setCellColor] = useState("rgb(25,118,210,0.15)");
  const [yearColor, setYearColor] = useState("");
  const [isFrozenYear, setIsFrozenYear] = React.useState<boolean>(false);
  const [isExelButton, setIsExelButton] = React.useState<boolean>(false);
  const [exportUrl, setExportUrl] = React.useState<string>(
    "segmentdemanddetermination/excel"
  );
  const { t } = useTranslation(["operation"]);
  const [loading, setIsLoading] = useState(false);
  const [refreshPage, setRefreshPage] = useState<boolean>(false);
  const [saveIds, setSaveIds] = useState<any>([]);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [percentageValues, setPercentageValues] = useState<any>([]);
  const { tenant } = useContext(ContextOperation);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  let objectFormatingValues: any;
  let rowForTheFirstTable = [
    "Budget",
    "RF",
    "Actual",
    "Act vs Fcst",
    "RF vs Budget",
  ];
  let rowForTheSecondTable = [
    "Mini",
    "Mini LEV",
    "Economy",
    "Economy LEV",
    "Compact",
    "Compact LEV",
    "Full size",
    "Full size LEV",
    "Intermediate",
    "Intermediate LEV",
    "LCV",
    "LCV LEV",
    "Minibus",
    "Minibus LEV",
    "Premium",
    "Standard",
    "Standard LEV",
    "Standard SUV",
    "Luxury",
    "Luxury LEV",
    "Premium",
    "Premium LEV"
  ];
  const rowHeight = 32;
  const rowHeight2 = 18;
  const rowHeight3 = 27;
  const rowHeightTotal = 43;

  function currencyFormatter(params: any) {
    if (params.value !== undefined || params.value == "") {
      if (params.data.subType2 === params.data.subType) {
        return Number(params?.value).toFixed(1) + "%";
      } else {
        return params.value;
      }
    }
  }

  function cellRender(params: any) {
    const field = params.colDef.field;
    const month = field.substring(0, field.indexOf("."));

    if ((params.data.subType === params.data.subType2)) {

      if (params.data.subType === 'Total') {

        const tmp = params?.data?.month.get(Number(month));

        if (tmp != null)
          return  <span>{Number(tmp).toFixed(1) + "%"} </span>;
        else 
          return <span></span>;

      } else {     
        return <span>{params.valueFormatted}</span>;
      }
    
    } else if (
      params.data.subType == "Act vs Fcst" ||
      params.data.subType == "RF vs Budget"
    ) {
      return <span>{params?.data[month]} %</span>;
    } else {
     
      if (params.data.subType === 'Total') {

        const tmp = params?.data?.month.get(Number(month));

        if (tmp != null)
          return  <span>{Number(tmp).toFixed(0)} </span>;
        else 
          return <span></span>;

      } else {     
        return <span style={{margin: '0 auto'}}>{params?.data[month]}</span>;
      }

    }
  }

  const isCellEditable = (params: any) => {
    return (params.data?.subType2 === params.data?.subType && params.data?.subType != "Total") ? true : false;
  };
  const rowSpan = (params: any) => {
    if (params.data.mainType === "Total Demand -") {
      return 2;
    } else {
      return 1;
    }
  };

  const onCellValueChanged =(params: any) => {
      if (Number(params.newValue)) {
        const field = params.colDef.field;
    const monthNumber = field.substring(0, field.indexOf("."));
  
        var oldValues = [...percentageValues];
        let foundPercentage = oldValues.find(
          (item: any) =>
          item.id === params.data[monthNumber].id
        );
        if (foundPercentage) {
          foundPercentage.newPercentage = Number(params.newValue);
        } else {
          oldValues.push({
        id: params.data[monthNumber].id,
        percentageToUpdate: (params.data[monthNumber].values),
          });
        }
        const idsPercentage = { id: params.data[monthNumber].id };
        setPercentageValues(oldValues);
        setSaveIds([...saveIds, idsPercentage]);
      }

    };
  const defaultColDef: any = {
    suppressMovable: true,
  };

 

  const myValueSetter = (params: any) => {
    if (!Number(params.newValue)) {
    
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t("fleetPlanning.messages.validNumber"),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
     
      return false;
     } 
     if (params.newValue > 100) {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t("fleetPlanning.messages.lessNumber"),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
      return false;
    } 
    else if (Math.sign(params.newValue) === -1) {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t("fleetPlanning.messages.negativValues"),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
      return false;
    }
    else{
      const index= params.colDef.field.split('.')[0];
      params.data[index].values = params.newValue;
      return true

    }
  
  };




// const handelChange = (params: any) => {
//   const field = params.colDef.field;
//   console.log(params,"params")
//   const monthNumber = field.substring(0, field.indexOf("."));

//   let oldValues = [...percentageValues];
//   const foundId = oldValues.find(
//     (item: any) => item.id === params.data[monthNumber].id
//   );
//   if (foundId) {
//     foundId.percentageToUpdate = parseInt(params.data[monthNumber].values);
//   } else {
//     oldValues.push({
//       id: params.data[monthNumber].id,
//       percentageToUpdate: parseInt(params.data[monthNumber].values),
//     });
//   }
//   const idsPercentage = { id: params.data[monthNumber].id };
//   setPercentageValues(oldValues);
//   setSaveIds([...saveIds, idsPercentage]);
// };

const tooltipForLabel = (subtype: string) => {
    
  if (subtype === 'PRF')
    return 'Proposal Rolling Forecast';
  else if (subtype === 'RF')
    return 'Rolling Forecast';
  else if (subtype === 'Act vs Fcst')
    return 'Act vs RF';
  else
    return subtype;

 
};


  const columnDefs: any = [
    {
      field: "mainType",
      headerName: "",
      flex: 1,
      minWidth: 135,
      headerClass: "header-white",
      resizable: true,
      rowSpan: rowSpan,
      pinned: "left",
      cellRenderer: (params: any) => {
        if (params.data.mainType === "Total Demand -") {
          return (
            <p style={{ fontSize: "13px", lineHeight: "20px" }}>
              <span style={{ display: "block" }}>Total</span>
              <span>Demand</span>
              <RemoveIcon className="minCircleIconClass" />
            </p>
          );
        } else if (params.data.mainType === "RF +") {
          return (
            <p>
              <span style={{ fontWeight: "700", fontSize: "13px" }}>
                RF
                <AddIcon className="addCircleIconClass" />
              </span>
            </p>
          );
        }
      },

      cellClass: (params: any) => {
        return params.data.mainType === "RF +" ? "rfClass" : "rag-green-outer";
      },
      cellStyle: {
        backgroundColor: "#F5F5F5",
        borderColor: "#F5F5F5",
        fontSize: "16px",
        resizeBy: "true",
        fontWeight: "700",
        borderRight: "2px solid #E0E0E0",
      },
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.mainType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      }

    },
    {
      field: "subType",
      headerName: "",
      flex: 1,
      minWidth: 120,
      pinned: "left",
      headerClass: "header-white",
     
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
      cellStyle: (params: any) => {
        if (rowForTheSecondTable.includes(params.data.subType2) || (params.data.subType === "Total" && params.data.subType2 === "Total")) {
          return {
            borderRight: " 2px solid #E0E0E0",
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            fontWeight: "400",
            color: "white",
            boxShadow: "0 0 0 0 white",
            position: "absolute",
            paddingTop: "0",
            zIndex: "0",
          };
        }
        if (rowForTheSecondTable.includes(params.data.subType)) {
          return {
            borderRight: " 2px solid #E0E0E0",
            backgroundColor: "white",
            display: "flex",
            alignItems: "flex-end",
            fontWeight: "400",
            color: "rgba(0, 0, 0)",
            boxShadow: "0 1px 0 0 white",
            position: "absolute",
            paddingTop: "36px",
            zIndex: "6",
          };
        }
        if ((params.data.subType === "Total" && params.data.subType2 === "RF")) {
          return {
            borderRight: " 2px solid #E0E0E0",
            backgroundColor: "white",
            display: "flex",
            alignItems: "flex-end",
            fontWeight: "700",
            color: "rgba(0, 0, 0)",
            boxShadow: "0 1px 0 0 white",
            position: "absolute",
            paddingTop: "36px",
            zIndex: "6",
          };
        }
        return null;
      },
      cellRenderer: (params: any) => {
        if (params.data.subType === 'RF' || params.data.subType === 'Budget' ||
          params.data.subType === 'Act vs Fcst' || params.data.subType === 'Actual' || params.data.subType === 'RF vs Budget')  {
           return (
          
              <Tooltip title={tooltipForLabel(params.data.subType)}>             
                  <span >{params.value}</span>
              </Tooltip>
          
          );
        } else if (params.data.subType === 'PRF') {
           return (
          
              <Tooltip title={tooltipForLabel(params.data.subType)}>             
                  <span style={{margin: '0 auto'}}>{params.value}</span>
              </Tooltip>
      
          );
        } else {
          return (
               <span>{params.value}</span>
        
        );
        }
      }
    },

    {
      field: "0.values",
      headerName: t("fleetPlanning.months.janary"),
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
      type: "editableColumn",
      valueSetter: myValueSetter,
      cellRenderer: cellRender,
      valueFormatter: currencyFormatter,
     
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "1.values",
      headerName: t("fleetPlanning.months.february"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
       cellRenderer: cellRender,
      valueSetter: myValueSetter,
      type: "editableColumn",
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "2.values",
      headerName: t("fleetPlanning.months.march"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      type: "editableColumn",
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "3.values",
      headerName: t("fleetPlanning.months.april"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
      type: "editableColumn",
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "4.values",
      headerName: t("fleetPlanning.months.may"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
      type: "editableColumn",
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "5.values",
      headerName: t("fleetPlanning.months.june"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "6.values",
      headerName: t("fleetPlanning.months.july"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "7.values",
      headerName: t("fleetPlanning.months.august"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "8.values",
      headerName: t("fleetPlanning.months.september"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        cellClass: (params: any) => params.data.subType === "Car Segment",
        percentageClass: (params: any) => params.data.subType === "PRF",
      },
    },
    {
      field: "9.values",
      headerName: t("fleetPlanning.months.october"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      maxWidth: 90,
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      cellClassRules: {
        cellClass: (params: any) => params.data.subType === "Car Segment",
        percentageClass: (params: any) => params.data.subType === "PRF",
      },
    },
    {
      field: "10.values",
      headerName: t("fleetPlanning.months.november"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      maxWidth: 90,
      type: "editableColumn",
      cellRenderer: cellRender,
       valueSetter: myValueSetter,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
    {
      field: "11.values",
      headerName: t("fleetPlanning.months.december"),
      valueFormatter: currencyFormatter,
      headerClass: "header-white",
      minWidth: 90,
      type: "editableColumn",
      cellRenderer: cellRender,
      valueSetter: myValueSetter,
      maxWidth: 90,
      cellClassRules: {
        percentageClass: (params: any) => params.data.subType === "PRF",
        cellClass: (params: any) => params.data.subType === "Car Segment",
      },
    },
  ];

  const getRows = (
    yearTo: number,
    yearFrom: number,
    monthFrom: number,
    monthTo: number
  ) => {
    setIsLoading(true);
    userDemand
      .getSegmentDemandDetermination(
        tenant,
        yearFrom,
        yearTo,
        monthFrom,
        monthTo
      )
      .then((response: any) => {
        setRows(manageData(response));
        setRowData(manageData(response));
        setRows2(manageDataForSecondTable(response));
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.error,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        } else {
        }
        setIsLoading(false);
      });
  };

  function manageData(response: any) {
    
    if (response !== undefined) {
      let channels = response?.totalGrossDemandDetermination;
      let carSegmentDemandDeterminations =
        response?.carSegmentDemandDeterminations;
      let rowsTable: any[] = new Array<any>();
      rowsTable = rowsTable.concat(buildRow(channels));
    
      const totalFleetPercObject = builTotalFleetPercentage(channels, response.carSegmentDemandDeterminations);
      const totalFleetRFObject = builTotalFleetRF(channels, response.carSegmentDemandDeterminations);
     
     
      if (carSegmentDemandDeterminations.length > 0) {
        let percentageRow = { mainType: "", subType: "Car Segment" };
        rowsTable = rowsTable.concat(percentageRow);
        rowsTable = rowsTable.concat(
          buildDatasForSecondTable(carSegmentDemandDeterminations)
        );
        rowsTable = rowsTable.concat(totalFleetRFObject);
        rowsTable = rowsTable.concat(totalFleetPercObject);
      }
      return rowsTable;
    }
  }

  function manageDataForSecondTable(response: any) {
    if (response !== undefined) {
      let rowsTable: any[] = new Array<any>();
      
      const totalFleetPercObject = builTotalFleetPercentage(response.totalGrossDemandDetermination,
        response.carSegmentDemandDeterminations);
      const totalFleetRFObject = builTotalFleetRF(response.totalGrossDemandDetermination,
        response.carSegmentDemandDeterminations);
     
      let percentageRow = { mainType: "", subType: "Car Segment" };
      rowsTable = rowsTable.concat(percentageRow);
      rowsTable = rowsTable.concat(
        buildDatasForSecondTable(response.carSegmentDemandDeterminations)
      );
      rowsTable = rowsTable.concat(totalFleetRFObject);
      rowsTable = rowsTable.concat(totalFleetPercObject);
      return rowsTable;
    }
  }

  function builTotalFleetPercentage(elements: any, carSegmentElements: any) {

    //console.log("builTotalFleet" + JSON.stringify(carSegmentElements));

    const group_to_percentageMonth =
    carSegmentElements.reduce(function (
        percentageSegmentDemandDeterminations: any,
        item: any
      ) {

        if (percentageSegmentDemandDeterminations[item.month - 1] === undefined)
        percentageSegmentDemandDeterminations[item.month - 1] = 0;

        percentageSegmentDemandDeterminations[item.month - 1] =
        percentageSegmentDemandDeterminations[item.month - 1] + item.demandPercentage;
       /* carSegmentDemandDeterminations[item.sapCarSegment][item.month - 1] =
          item.splittedRf;*/
        return percentageSegmentDemandDeterminations;
      },
      {});


    let objectWithAllMonthValues: any = { month: new Map<number, number>(), subType: 'Total', subType2: 'Total' };

    
    for (let i = 0; i < 12 ; i++) {
      
      objectWithAllMonthValues.month.set(
        i,
        group_to_percentageMonth[i]);

    }
   
    //return buildDatas(elements, "rf");
    return objectWithAllMonthValues;
  }

  function builTotalFleetRF(elements: any, carSegmentElements: any) {

    
    const group_to_rfMonth =
      carSegmentElements.reduce(function (
        percentageSegmentDemandDeterminations: any,
        item: any
      ) {

        if (percentageSegmentDemandDeterminations[item.month - 1] === undefined)
        percentageSegmentDemandDeterminations[item.month - 1] = 0;

        percentageSegmentDemandDeterminations[item.month - 1] =
        percentageSegmentDemandDeterminations[item.month - 1] + item.splittedRf;
        return percentageSegmentDemandDeterminations;
      },
      {});


    let objectWithAllMonthValues: any = { month: new Map<number, any[]>(), subType: 'Total', subType2: 'RF' };

    
    for (let i = 0; i < 12 ; i++) {
      
      objectWithAllMonthValues.month.set(
        i,
        group_to_rfMonth[i]);

    }
   
    //return buildDatas(elements, "rf");
    return objectWithAllMonthValues;
  }

  function buildRow(elements: any) {
    let arrayChannel: any[] = [];
    if (elements) {
      arrayChannel.push(buildDatas(elements, "budget"));
      arrayChannel.push(buildDatas(elements, "rf"));
      arrayChannel.push(buildDatas(elements, "rfProposal"));
      arrayChannel.push(buildDatas(elements, "actual"));
      arrayChannel.push(buildDatas(elements, "actualVsRF"));
      arrayChannel.push(buildDatas(elements, "rfVsBgt"));
      return arrayChannel;
    } else {
      return arrayChannel;
    }
  }

  function buildDatasForSecondTable(carSegmentDemandDeterminationsArray: any) {
    let group_to_carSegmentDemandDeterminations =
      carSegmentDemandDeterminationsArray.reduce(function (
        carSegmentDemandDeterminations: any,
        item: any
      ) {
        carSegmentDemandDeterminations[item.sapCarSegment] =
          carSegmentDemandDeterminations[item.sapCarSegment] ||
          Array(12).fill("");
        carSegmentDemandDeterminations[item.sapCarSegment][item.month - 1] =
          item.splittedRf;
        return carSegmentDemandDeterminations;
      },
      {});

    let group_to_carSegmentPercentageDemand =
      carSegmentDemandDeterminationsArray.reduce(function (
        carSegmentPercentageDemand: any,
        item: any
      ) {
        carSegmentPercentageDemand[item.sapCarSegment] =
          carSegmentPercentageDemand[item.sapCarSegment] || Array(12).fill("");
        const percentageValue = { values: item.demandPercentage, id: item.id };
        const object1 = { values: item.demandPercentage, id: item.id };
        carSegmentPercentageDemand[item.sapCarSegment][item.month - 1] =
          percentageValue;
        // }
        return carSegmentPercentageDemand;
      },
      {});
    var carSegmentDemandDeterminationsGroups = Object.keys(
      group_to_carSegmentDemandDeterminations
    ).map(function (key, index) {
      return {
        subType: key,
        ...Object.assign({}, group_to_carSegmentDemandDeterminations[key]),
      };
    });

    var carSegmentPercentageDemandGroups = Object.keys(
      group_to_carSegmentPercentageDemand
    ).map(function (key, index) {
      return {
        subType2: key,
        ...Object.assign({}, group_to_carSegmentPercentageDemand[key]),
      };
    });

    const filtredcarSegmentDemandDeterminations =
      carSegmentDemandDeterminationsArray.filter(
        (a: any, i: any) =>
          carSegmentDemandDeterminationsArray.findIndex(
            (s: any) => a.sapCarSegment === s.sapCarSegment
          ) == i
      );

    let newcarSegmentDemandDeterminationsArray =
      filtredcarSegmentDemandDeterminations.map((item: any, i: any) =>
        Object.assign({}, item, carSegmentDemandDeterminationsGroups[i])
      );
    let newcarSegmentPercentageDemandArray =
      filtredcarSegmentDemandDeterminations.map((item: any, i: any) =>
        Object.assign({}, item, carSegmentPercentageDemandGroups[i])
      );

    const manipulationcarSegmentDemandDeterminationsArray = [
      ...newcarSegmentDemandDeterminationsArray,
      ...newcarSegmentPercentageDemandArray,
    ].map((res: any) => ({
      ...(res.subType2 && { subType: res.subType2 }),
      ...res,
    }));

    //console.log("manipulationcarSegmentDemandDeterminationsArray: " + JSON.stringify(manipulationcarSegmentDemandDeterminationsArray));

    return manipulationcarSegmentDemandDeterminationsArray.sort((a, b) =>
      a.subType.localeCompare(b.subType)
    );
  }

  function buildDatas(totalGrossDemandDetermination: any, row: any) {
    let objectWithAllMonthValues: any = { month: new Map<number, string>() };
    let arrayMonths: any[] = [];
    for (let index = 1; index <= 12; index++) {
      arrayMonths.push(index);
    }
    if (row === "rfProposal") {
      const mainType = totalGrossDemandDetermination[0].channel;
      grossDemandDeterminationObject.mainType = convertMainTitle(mainType);
    } else {
      grossDemandDeterminationObject.mainType = "";
    }

    grossDemandDeterminationObject.subType = convertSubTitle(row);

    arrayMonths.forEach((month: any, index: any) => {
      let totalGrossDemandDeterminationObject =
        totalGrossDemandDetermination.find((ele: any) => ele.month === month);
      if (totalGrossDemandDeterminationObject !== undefined) {
        if (totalGrossDemandDeterminationObject[row] !== null) {
          objectWithAllMonthValues.month.set(
            index,
            totalGrossDemandDeterminationObject[row].toString()
          );
          objectFormatingValues = Object.fromEntries(
            objectWithAllMonthValues.month
          );
        } else {
          objectWithAllMonthValues.month.set(
            index + 1,
            totalGrossDemandDeterminationObject[row]
          );
          objectFormatingValues = Object.fromEntries(
            objectWithAllMonthValues.month
          );
        }
      }
    });
    objectFormatingValues.subType = grossDemandDeterminationObject.subType;
    objectFormatingValues.fullYear = grossDemandDeterminationObject.fullYear;
    objectFormatingValues.mainType = grossDemandDeterminationObject.mainType;
    objectWithAllMonthValues.month = objectFormatingValues;
    return objectWithAllMonthValues.month;
  }

  function convertSubTitle(subTitle: any) {
    let subTitleString;
    switch (subTitle) {
      case "budget":
        return (subTitleString =
          subTitle.charAt(0).toUpperCase() + subTitle.slice(1));

      case "rf":
        return (subTitleString = subTitle.toUpperCase());
      case "rfProposal":
        return (subTitleString = "PRF");
      case "actual":
        return (subTitleString = "Actual");
      case "actualVsRF":
        return (subTitleString = "Act vs Fcst");
      case "rfVsBgt":
        return (subTitleString = "RF vs Budget");
    }
  }

  function convertMainTitle(mainType: any) {
    let mainTitleString: string;
    switch (mainType) {
      case "TOTAL DEMAND":
        return (mainTitleString = "Total Demand -");
    }
  }

  const onCellClick = (params: CellClickedEvent) => {
    if (params.data.mainType === "Total Demand -") {
      let subType = "RF";
      let rowTemp = JSON.parse(
        JSON.stringify(rows.filter((r: any) => r.subType === subType))
      );
      rowTemp[0].mainType = "RF +";
      rowTemp[0].subType = "";
      setRows([...rowTemp, ...rows2]);
    } else if (params.data.mainType === "RF +") {
      setRows(rowData);
    }
  };

  const columnTypes = useMemo(() => {
    return {
      editableColumn: {
        editable: (params: any) => {
         
          return isCellEditable(params);
        },
        cellStyle: (params: any) => {
          if (isCellEditable(params)) {
            return { height: "18px" };
          } else {
            return { height: "32px" };
          }
        },
      },
    };
  }, []);



  function updatePercentage() {
    if (percentageValues.length !== 0) {
      setIsLoading(true);
      const objectUpdate = {
        refreshRequest: {
          //tenant: "IT",
          yearFrom: year,
          yearTo: year,
          monthFrom: 1,
          monthTo: 12,
        },
        updateRequests: percentageValues,
      };
      
      userDemand
        .updatePercentageSegmentDemandDetermination(tenant, objectUpdate)
        .then((response: any) => {
          setIsLoading(false);
          props.setRefreshButton(!props.refreshButton);
        })
        .catch((error: any) => {
          if (error.response) {
            if (error.response.status === 400) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t(
                      "fleetPlanning.grossDemandDetermination.messageForBadRequestPercentage"
                    ),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
              props.setRefreshButton(!props.refreshButton);
            } else {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            }
          } else if (error.request) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t("networkErrorMessage"),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
            setIsLoading(false);
          } else {
          }
          setIsLoading(false);
        });
      setPercentageValues([]);
    }
  }

  function resetYearPercentage() {
    if (saveIds.length !== 0) {
      const resetPercentageObject = {
        refreshRequest: {
          //tenant: "IT",
          yearFrom: year,
          yearTo: year,
          monthFrom: 1,
          monthTo: 12,
        },
        resetRequests: saveIds,
      };

      userDemand
        .resetPercentage(tenant, resetPercentageObject)
        .then((reset: any) => {
          props.setRefreshButton(!props.refreshButton);
        });

      setSaveIds([]);
    }
  }

  const rowClassRules = useMemo(() => {
    return {
      cellRowClass: (params: any) => {
        return rowForTheFirstTable.includes(params.data.subType);
      },
      rfClass: (params: any) => {
        return params.data.mainType === "RF +";
      },
      cellNewRowClass: (params: any) => {
        return params.data.subType === "Total";
      },

      "rag-grey-outer": (params: any) => {
        return rowForTheSecondTable.includes(params.data.subType);
      },
      hideClass: (params: any) => {
        return params.data.subType2 === params.data.subType;
      },
    };
  }, []);

  function getRowHeight(params: any) {
    if (params.data.subType2 === params.data.subType) {
      if (params.data.subType === "Total") {
        return rowHeight3;
      } else {
        return rowHeight2;
      }
    } else if (params.data.subType === "Total") {
      return rowHeightTotal;
    } else {
      return rowHeight;
    }
  }
  // Example load data from sever
  useEffect(() => {
    if (year > new Date().getFullYear()) {
      setYearColor("#00A0DF");
      setCellColor("rgba(0, 160, 223, 0.1)");
    } else if (year < new Date().getFullYear()) {
      setYearColor("#C8017D");
      setCellColor("rgba(255, 255, 255, 1)");
    } else {
      setYearColor("#011E41");
      setCellColor("rgb(1, 30, 65, 0.1)");
    }

    getRows(year, year, 1, 12);
  }, [year, props.refreshButton]);

  return (
    <Box sx={{ padding: "20px 20px 20px 20px" }}>
      <FleetPlanningToolbar
        rows={rows}
        year={year}
        yearColor={yearColor}
        setIsFrozenYear={setIsFrozenYear}
        isFrozenYear={isFrozenYear}
        isExelButton={isExelButton}
        exportUrl={exportUrl}
      />
      <Box
        className="grid ag-theme-alpine"
        style={{
          borderRadius: 4,
        }}
        sx={{
          "& .ag-cell": {
            lineHeight: "min(var(--ag-line-height, 40px), 40px)",
          },
        }}
      >
        <AgGridReact
         ref={gridRef}
          domLayout="autoHeight"
          getRowHeight={getRowHeight}
          rowData={rows}
          columnDefs={columnDefs}
          onCellClicked={onCellClick}
          rowClassRules={rowClassRules}
          columnTypes={columnTypes}
          onCellValueChanged={onCellValueChanged}
          defaultColDef={defaultColDef}
          // suppressRowTransform={true}
          suppressRowHoverHighlight={true}
        />

      </Box>
      <Box style={{ marginBottom: "5px" }}>
        <FleetPlanningFooter
          year={year}
          setYear={setYear}
          yearColor={yearColor}
        />
      </Box>
      {hasScope("SCOPE_UPDATE_CSD_PLANNING") && (
        <Box
          sx={{
            justifyContent: "flex-end",
            display: "flex",
            paddingTop: "10px",
          }}
        >
          <Mui.Grid container spacing={2} justifyContent="end">
              <Mui.Grid item xs={6} sm={3} lg={1.1}>

              <Mui.Button variant="outlined" onClick={resetYearPercentage} fullWidth startIcon={<Replay />}>
                    <Mui.Typography variant="h6" color={'accent'}>
                    {t("actionButtons.reset")}
                    </Mui.Typography>
                </Mui.Button>

              </Mui.Grid>

              <Mui.Grid item xs={6} sm={3} lg={1.15}>

              <Mui.Button onClick={updatePercentage} fullWidth >
                    <Mui.Typography variant="h6" color={'accent'}>
                    {t("actionButtons.save")}
                    </Mui.Typography>
                </Mui.Button>
              </Mui.Grid>
            </Mui.Grid>

        </Box>
      )}

      {loading && <CustomLoader loading={loading} />}
    </Box>
  );
};

export default GrossCarSegmentDDTable;
